package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Build
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.List
import androidx.compose.material.icons.filled.LocationOn
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.Icon
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import br.com.htms.inspeccaocampo.data.TagConfig
import br.com.htms.inspeccaocampo.data.colaboradores.ColabEscopo
import br.com.htms.inspeccaocampo.data.colaboradores.ColabEscopoTag
import br.com.htms.inspeccaocampo.data.colaboradores.DocsMatriz
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.kit.TituloSecao
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.CampoConfig
import br.com.htms.inspeccaocampo.data.FormEmailDestino
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.platform.randomUuid
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import androidx.compose.material3.Checkbox
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

/** Callbacks registrados pela tela de Config para a TopAppBar (Voltar / Salvar). */
class ConfigHeaderActions {
    var onSalvar: (() -> Unit)? = null
    var onVoltar: (() -> Unit)? = null
}

private enum class ConfigSubPage {
    HUB,
    INSPECAO,
    ALOJAMENTO,
    OCORRENCIAS
}

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun SharedConfigScreen(
    controller: AppController,
    snackbar: SnackbarHostState,
    headerActions: ConfigHeaderActions,
    onVoltar: () -> Unit
) {
    val configAtual by controller.appConfig.collectAsState()
    val modoTreinamento by controller.modoTreinamento.collectAsState()
    val authUser by controller.authUser.collectAsState()
    // Com login: só Master edita config do app. Sem sessão (senha local): libera edição.
    val canEditAppConfig = authUser == null || authUser?.podeEditarCamposMaster == true
    val isMaster = authUser?.isMaster == true
    val scope = rememberCoroutineScope()
    val focusManager = LocalFocusManager.current

    var draft by remember { mutableStateOf(configAtual) }
    var salvando by remember { mutableStateOf(false) }
    var novoCampoTitulo by remember { mutableStateOf("") }
    var importJson by remember { mutableStateOf("") }
    var mostrarImport by remember { mutableStateOf(false) }
    var mostrarAcessoForm by remember { mutableStateOf(false) }
    var subPage by remember { mutableStateOf(ConfigSubPage.HUB) }
    var aba by remember { mutableStateOf("") }
    val draftLatest = rememberUpdatedState(draft)
    val canEditLatest = rememberUpdatedState(canEditAppConfig)

    // Ao abrir Config, alinha o rascunho com o que está aplicado (inclui sync remoto).
    LaunchedEffect(Unit) {
        draft = controller.appConfig.value
    }

    fun salvarAplicar() {
        if (!canEditLatest.value) {
            scope.launch {
                snackbar.showSnackbar("Sem permissão para alterar a configuração. Somente o admin master altera esses campos.")
            }
            return
        }
        if (salvando) return
        salvando = true
        // Garante que o texto ainda em edição no TextField entre no draft antes de gravar.
        focusManager.clearFocus(force = true)
        scope.launch {
            try {
                delay(48)
                // Listas da regra antiga de acesso não são editadas aqui; preserva o que está no servidor.
                val toSave = draftLatest.value.copy(
                    tags = draftLatest.value.tagsSanitizadas(),
                    emissaoDocUsuarios = controller.appConfig.value.emissaoDocUsuarios,
                    ativosUsuarios = controller.appConfig.value.ativosUsuarios
                )
                val erro = controller.aplicarConfiguracao(toSave)
                if (erro == null) {
                    draft = controller.appConfig.value
                    snackbar.showSnackbar("Configuração salva e aplicada.")
                } else {
                    snackbar.showSnackbar(erro)
                }
            } finally {
                salvando = false
            }
        }
    }

    SideEffect {
        headerActions.onSalvar = if (canEditAppConfig) ({ salvarAplicar() }) else null
        headerActions.onVoltar = {
            if (subPage != ConfigSubPage.HUB) {
                subPage = ConfigSubPage.HUB
            } else {
                onVoltar()
            }
        }
    }
    DisposableEffect(headerActions) {
        onDispose {
            headerActions.onSalvar = null
            headerActions.onVoltar = null
        }
    }

    val itensMenu = buildList {
        if (isMaster) {
            add(PortalMenuItem("USUARIOS", "Usuários", Icons.Filled.Person))
            add(PortalMenuItem("LOG", "Log de acesso", Icons.Filled.List))
            add(PortalMenuItem("LIXEIRA", "Lixeira", Icons.Filled.Delete))
            add(PortalMenuItem("OBRAS", "Obras", Icons.Filled.LocationOn))
        }
        if (canEditAppConfig) {
            add(PortalMenuItem("GERAL", "Identidade e e-mails", Icons.Filled.Settings))
            add(PortalMenuItem("TAGS", "TAGs", Icons.Filled.Person))
            add(PortalMenuItem("CHECKLISTS", "Checklists", Icons.Filled.Build))
            add(PortalMenuItem("SISTEMA", "Treinamento e backup", Icons.Filled.Info))
        }
    }
    val abaAtual = if (itensMenu.any { it.chave == aba }) aba else itensMenu.firstOrNull()?.chave.orEmpty()

    PortalModulo(
        titulo = "Configurações",
        itens = itensMenu,
        selecionado = abaAtual,
        onSelect = {
            aba = it
            subPage = ConfigSubPage.HUB
        },
        extraCabecalho = {
            if (canEditAppConfig) {
                PortalButton(onClick = { salvarAplicar() }, enabled = !salvando) {
                    Icon(Icons.Filled.Check, contentDescription = null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(6.dp))
                    Text(if (salvando) "Salvando..." else "Salvar / Aplicar")
                }
            }
        }
    ) { _ ->
        Text(
            if (canEditAppConfig) {
                "Alterações (identidade, e-mails, acessos e checklists) só valem após Salvar / Aplicar. " +
                    "No portal web a config é sincronizada no servidor para todos os usuários."
            } else {
                "Somente o admin master altera identidade, formulários, e-mails, checklists e obras. " +
                    "Usuários comuns entram para consultar. A edição do conteúdo de cada módulo fica na matriz de acessos."
            },
            style = MaterialTheme.typography.bodySmall,
            color = PortalCores.CinzaTexto
        )
        when (abaAtual) {
            "USUARIOS" -> SharedAdminUsersPanel(
                isMaster = isMaster,
                tags = draft.tagsEfetivas(),
                onMessage = { msg -> scope.launch { snackbar.showSnackbar(msg) } },
            )
            "TAGS" -> TagsConfigCard(
                tags = draft.tagsEfetivas(),
                escopoDe = { ColabEscopo.daTag(draft, it) },
                onEscopo = { draft = draft.definirColabEscopo(it) },
                onAtualizar = { idAtual, novoId, rotulo ->
                    draft = draft.atualizarTag(idAtual, novoId, rotulo)
                },
                onExcluir = { id -> draft = draft.excluirTag(id) },
                onAdicionar = { id, rotulo ->
                    val proximo = draft.adicionarTag(id, rotulo)
                    val ok = proximo.tagsEfetivas().size > draft.tagsEfetivas().size
                    draft = proximo
                    ok
                }
            )
            "LOG" -> Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                SharedLogsModulosPanel(onMessage = { msg -> scope.launch { snackbar.showSnackbar(msg) } })
                SharedAccessLogPanel(onMessage = { msg -> scope.launch { snackbar.showSnackbar(msg) } })
            }
            "LIXEIRA" -> SharedTrashPanel(onMessage = { msg -> scope.launch { snackbar.showSnackbar(msg) } })
            "OBRAS" -> SharedAdminObrasPanel(
                controller = controller,
                onMessage = { msg -> scope.launch { snackbar.showSnackbar(msg) } }
            )
            "GERAL" -> {
                Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        TituloSecao("Identidade")
                        AppOutlinedTextField(
                            value = draft.nomeApp,
                            onValueChange = { draft = draft.copy(nomeApp = it) },
                            label = { Text("Nome no topo") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppOutlinedTextField(
                            value = draft.nomeInspecao,
                            onValueChange = { draft = draft.copy(nomeInspecao = it) },
                            label = { Text("Subtítulo do portal (ex.: Portal QSSMA)") },
                            modifier = Modifier.fillMaxWidth(),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        Text(
                            if (draft.bannerPath != null) "Banner personalizado ativo"
                            else "Usando banner padrão (nome no topo)",
                            style = MaterialTheme.typography.bodySmall
                        )
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            PortalOutlinedButton(
                                onClick = {
                                    controller.definirBannerDaGaleria()
                                    scope.launch {
                                        delay(400)
                                        // Preserva edições locais (TST/ADM, e-mails); só puxa o banner.
                                        draft = draft.copy(
                                            bannerPath = controller.appConfig.value.bannerPath
                                        )
                                    }
                                },
                                modifier = Modifier.weight(1f)
                            ) { Text("Trocar logo/banner") }
                            PortalOutlinedButton(
                                onClick = {
                                    controller.restaurarBannerPadrao()
                                    draft = draft.copy(bannerPath = null)
                                    scope.launch { snackbar.showSnackbar("Banner padrão restaurado.") }
                                },
                                modifier = Modifier.weight(1f)
                            ) { Text("Restaurar padrão") }
                        }
                    }
                }

                Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Text(
                                "E-mail do aviso por formulário",
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier.weight(1f),
                                color = PortalCores.Navy
                            )
                            TextButton(onClick = { mostrarAcessoForm = !mostrarAcessoForm }) {
                                Text(if (mostrarAcessoForm) "Ocultar" else "Mostrar")
                            }
                        }
                        if (mostrarAcessoForm) {
                            Text(
                                "Para qual caixa vai o aviso de cada formulário, inclusive o Controle de vetores. " +
                                    "Dá para incluir outros destinatários no campo de e-mails adicionais, separados por vírgula. " +
                                    "Quem pode usar cada formulário é definido no cadastro do usuário " +
                                    "(Usuários → Editar → Acessos) ou na Matriz de acessos.",
                                style = MaterialTheme.typography.bodySmall
                            )
                            FormTipo.hubEntries.forEach { tipo ->
                                val acesso = draft.acessoDoForm(tipo)
                                Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                    Text(tipo.rotulo, fontWeight = FontWeight.SemiBold)
                                    br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                                        label = "E-mail do aviso",
                                        opcoes = FormEmailDestino.entries.map { it.name to it.rotulo },
                                        selecionado = acesso.emailDestino.name,
                                        onSelect = { n ->
                                            FormEmailDestino.entries.firstOrNull { it.name == n }?.let { draft = draft.comEmailForm(tipo, it) }
                                        }
                                    )
                                    AppOutlinedTextField(
                                        value = acesso.emailsExtras,
                                        onValueChange = { draft = draft.comEmailsExtras(tipo, it) },
                                        label = { Text("E-mails adicionais") },
                                        placeholder = { Text("outro@empresa.com, mais@empresa.com") },
                                        modifier = Modifier.fillMaxWidth(),
                                        singleLine = true
                                    )
                                }
                            }
                        }
                    }
                }

                Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        TituloSecao("Endereços de e-mail (TST / ADM)")
                        Text(
                            "Usados pelo seletor \"E-mail do aviso\". Vários endereços na mesma caixa: separe por vírgula.",
                            style = MaterialTheme.typography.bodySmall
                        )
                        AppOutlinedTextField(
                            value = draft.emailDestinoTst,
                            onValueChange = { draft = draft.copy(emailDestinoTst = it) },
                            label = { Text("E-mail TST") },
                            modifier = Modifier.fillMaxWidth(),
                            singleLine = true
                        )
                        AppOutlinedTextField(
                            value = draft.emailDestinoAdm,
                            onValueChange = { draft = draft.copy(emailDestinoAdm = it) },
                            label = { Text("E-mail ADM") },
                            modifier = Modifier.fillMaxWidth(),
                            singleLine = true
                        )
                    }
                }
            }
            "CHECKLISTS" -> when (subPage) {
                ConfigSubPage.HUB -> {
                    Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                        Column(
                            modifier = Modifier.padding(12.dp),
                            verticalArrangement = Arrangement.spacedBy(10.dp)
                        ) {
                            TituloSecao("Configuração por checklist")
                            Text(
                                "Abra a configuração de campos de cada formulário.",
                                style = MaterialTheme.typography.bodySmall
                            )
                            ChecklistConfigEntry(
                                titulo = "Inspeção de Campo Diária",
                                descricao = "Campos de verificação (Sim/Não/N/A), obrigatoriedade e fotos."
                            ) { subPage = ConfigSubPage.INSPECAO }
                            ChecklistConfigEntry(
                                titulo = "Relatório Alojamento",
                                descricao = "Parte 1 (fotos) e Parte 2 (checklist) em uma só tela."
                            ) { subPage = ConfigSubPage.ALOJAMENTO }
                            ChecklistConfigEntry(
                                titulo = "Comunicação Prévia de ocorrências",
                                descricao = "Ativar/desativar e renomear blocos do formulário."
                            ) { subPage = ConfigSubPage.OCORRENCIAS }
                        }
                    }
                }
                ConfigSubPage.INSPECAO -> {
                    ConfigSubHeader(
                        titulo = "Inspeção de Campo Diária",
                        onVoltarHub = { subPage = ConfigSubPage.HUB }
                    )
                    CamposVerificacaoEditor(
                        campos = draft.campos,
                        novoCampoTitulo = novoCampoTitulo,
                        onNovoCampoTitulo = { novoCampoTitulo = it },
                        onCamposChange = { draft = draft.copy(campos = it) },
                        permitirAdicionar = true,
                        mostrarFotos = true
                    )
                    if (canEditAppConfig) {
                        PortalButton(
                            onClick = { salvarAplicar() },
                            modifier = Modifier.fillMaxWidth(),
                            enabled = !salvando
                        ) {
                            Text(if (salvando) "Salvando..." else "Salvar / Aplicar")
                        }
                    }
                }
                ConfigSubPage.ALOJAMENTO -> {
                    ConfigSubHeader(
                        titulo = "Relatório Alojamento",
                        onVoltarHub = { subPage = ConfigSubPage.HUB }
                    )
                    Text(
                        "Parte 1 — Relatório fotográfico",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        color = PortalCores.Navy
                    )
                    Text(
                        "Ative/desative itens e ajuste títulos. Itens inativos somem de novos formulários.",
                        style = MaterialTheme.typography.bodySmall
                    )
                    CamposVerificacaoEditor(
                        campos = draft.camposAlojamentoFoto,
                        novoCampoTitulo = "",
                        onNovoCampoTitulo = {},
                        onCamposChange = { draft = draft.copy(camposAlojamentoFoto = it) },
                        permitirAdicionar = false,
                        mostrarFotos = true,
                        rotuloFotoSim = "Foto obrigatória"
                    )
                    Text(
                        "Parte 2 — Checklist",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleMedium,
                        color = PortalCores.Navy
                    )
                    CamposVerificacaoEditor(
                        campos = draft.camposAlojamentoChecklist,
                        novoCampoTitulo = "",
                        onNovoCampoTitulo = {},
                        onCamposChange = { draft = draft.copy(camposAlojamentoChecklist = it) },
                        permitirAdicionar = false,
                        mostrarFotos = false
                    )
                    if (canEditAppConfig) {
                        PortalButton(
                            onClick = { salvarAplicar() },
                            modifier = Modifier.fillMaxWidth(),
                            enabled = !salvando
                        ) {
                            Text(if (salvando) "Salvando..." else "Salvar / Aplicar")
                        }
                    }
                }
                ConfigSubPage.OCORRENCIAS -> {
                    ConfigSubHeader(
                        titulo = "Comunicação Prévia de ocorrências",
                        onVoltarHub = { subPage = ConfigSubPage.HUB }
                    )
                    Text(
                        "Ative/desative blocos do formulário e ajuste os rótulos exibidos.",
                        style = MaterialTheme.typography.bodySmall
                    )
                    CamposVerificacaoEditor(
                        campos = draft.camposOcorrencias,
                        novoCampoTitulo = "",
                        onNovoCampoTitulo = {},
                        onCamposChange = { draft = draft.copy(camposOcorrencias = it) },
                        permitirAdicionar = false,
                        mostrarFotos = false,
                        mostrarObrigatorio = false
                    )
                    if (canEditAppConfig) {
                        PortalButton(
                            onClick = { salvarAplicar() },
                            modifier = Modifier.fillMaxWidth(),
                            enabled = !salvando
                        ) {
                            Text(if (salvando) "Salvando..." else "Salvar / Aplicar")
                        }
                    }
                }
            }
            "SISTEMA" -> {
                Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        TituloSecao("Modo treinamento")
                        Text(
                            if (modoTreinamento) "Ativo — inspeções de exemplo não vão ao histórico."
                            else "Inativo."
                        )
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            PortalOutlinedButton(
                                onClick = { controller.ativarTreinamento() },
                                modifier = Modifier.weight(1f),
                                enabled = !modoTreinamento
                            ) { Text("Ativar") }
                            PortalOutlinedButton(
                                onClick = { controller.desativarTreinamento() },
                                modifier = Modifier.weight(1f),
                                enabled = modoTreinamento
                            ) { Text("Desativar") }
                        }
                    }
                }

                var testandoSharePoint by remember { mutableStateOf(false) }
                Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        TituloSecao("Backup no SharePoint")
                        Text(
                            "Todo PDF, Excel, CSV e PPTX gerado no portal recebe uma cópia na biblioteca " +
                                "\"Portal HTMS Backup\" (Módulo / Formulário / Obra / Ano / Mês).",
                            style = MaterialTheme.typography.bodySmall,
                            color = PortalCores.CinzaTexto
                        )
                        PortalOutlinedButton(
                            enabled = !testandoSharePoint,
                            onClick = {
                                testandoSharePoint = true
                                scope.launch {
                                    val msg = br.com.htms.inspeccaocampo.platform.BackupSharePoint.testarConexao().fold(
                                        onSuccess = { resp ->
                                            if (resp.trimStart().startsWith("{\"ok\":true")) {
                                                "SharePoint OK: arquivo de teste gravado e acesso fora da biblioteca bloqueado."
                                            } else {
                                                val detalhe = Regex("\"(?:error|detalhe)\":\"((?:\\\\.|[^\"\\\\])*)\"")
                                                    .findAll(resp).joinToString(" | ") { it.groupValues[1] }
                                                "SharePoint com problema: ${detalhe.ifBlank { resp.take(200) }}"
                                            }
                                        },
                                        onFailure = { "SharePoint indisponível: ${it.message}" }
                                    )
                                    testandoSharePoint = false
                                    snackbar.showSnackbar(msg)
                                }
                            }
                        ) { Text(if (testandoSharePoint) "Testando..." else "Testar conexão com SharePoint") }
                    }
                }

                Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
                    Column(
                        modifier = Modifier.padding(12.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        TituloSecao("Backup da configuração")
                        PortalOutlinedButton(
                            onClick = { controller.exportarConfig() },
                            modifier = Modifier.fillMaxWidth()
                        ) { Text("Exportar configuração (JSON)") }
                        PortalOutlinedButton(
                            onClick = { mostrarImport = !mostrarImport },
                            modifier = Modifier.fillMaxWidth()
                        ) { Text(if (mostrarImport) "Ocultar importação" else "Importar configuração (colar JSON)") }
                        if (mostrarImport) {
                            AppOutlinedTextField(
                                value = importJson,
                                onValueChange = { importJson = it },
                                label = { Text("Cole o JSON aqui") },
                                modifier = Modifier.fillMaxWidth(),
                                minLines = 4,
                                colors = FormFieldDefaults.textFieldColors()
                            )
                            PortalButton(
                                onClick = {
                                    controller.importarConfigTexto(importJson)
                                    scope.launch {
                                        delay(400)
                                        draft = controller.appConfig.value
                                    }
                                    importJson = ""
                                    mostrarImport = false
                                },
                                modifier = Modifier.fillMaxWidth(),
                                enabled = importJson.isNotBlank()
                            ) { Text("Aplicar JSON importado") }
                        }
                    }
                }
            }
            else -> Text("Seu usuário não tem opções de configuração.", color = PortalCores.CinzaTexto)
        }
    }
}

@Composable
private fun ConfigSubHeader(titulo: String, onVoltarHub: () -> Unit) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Text(
            titulo,
            style = MaterialTheme.typography.titleLarge,
            fontWeight = FontWeight.Bold,
            color = PortalCores.Navy,
            modifier = Modifier.weight(1f)
        )
        TextButton(onClick = onVoltarHub) { Text("Voltar aos checklists") }
    }
}

@Composable
private fun ChecklistConfigEntry(
    titulo: String,
    descricao: String,
    onOpen: () -> Unit
) {
    Card(
        onClick = onOpen,
        colors = CardDefaults.cardColors(containerColor = PortalCores.AzulClaro),
        border = PortalCores.BordaCartao,
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            TituloSecao(titulo)
            Text(descricao, style = MaterialTheme.typography.bodySmall)
            Text("Abrir configuração", color = MaterialTheme.colorScheme.primary, fontWeight = FontWeight.SemiBold)
        }
    }
}

@Composable
private fun CamposVerificacaoEditor(
    campos: List<CampoConfig>,
    novoCampoTitulo: String,
    onNovoCampoTitulo: (String) -> Unit,
    onCamposChange: (List<CampoConfig>) -> Unit,
    permitirAdicionar: Boolean,
    mostrarFotos: Boolean,
    mostrarObrigatorio: Boolean = true,
    rotuloFotoSim: String = "Foto se Sim",
    rotuloFotoNao: String = "Foto se Não"
) {
    Card(colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            TituloSecao("Campos")
            campos.forEachIndexed { index, campo ->
                CampoConfigEditor(
                    campo = campo,
                    onChange = { atualizado ->
                        onCamposChange(
                            campos.toMutableList().also { it[index] = atualizado }
                        )
                    },
                    onRemover = if (permitirAdicionar) {
                        { onCamposChange(campos.filterIndexed { i, _ -> i != index }) }
                    } else null,
                    mostrarFotos = mostrarFotos,
                    mostrarObrigatorio = mostrarObrigatorio,
                    rotuloFotoSim = rotuloFotoSim,
                    rotuloFotoNao = rotuloFotoNao
                )
            }
            if (permitirAdicionar) {
                AppOutlinedTextField(
                    value = novoCampoTitulo,
                    onValueChange = onNovoCampoTitulo,
                    label = { Text("Novo campo") },
                    modifier = Modifier.fillMaxWidth(),
                    colors = FormFieldDefaults.textFieldColors()
                )
                PortalOutlinedButton(
                    onClick = {
                        val titulo = novoCampoTitulo.trim()
                        if (titulo.isNotEmpty()) {
                            onCamposChange(
                                campos + CampoConfig(
                                    id = "campo_${randomUuid()}",
                                    titulo = titulo
                                )
                            )
                            onNovoCampoTitulo("")
                        }
                    },
                    modifier = Modifier.fillMaxWidth()
                ) { Text("Adicionar campo") }
            }
        }
    }
}

@Composable
private fun CampoConfigEditor(
    campo: CampoConfig,
    onChange: (CampoConfig) -> Unit,
    onRemover: (() -> Unit)?,
    mostrarFotos: Boolean,
    mostrarObrigatorio: Boolean,
    rotuloFotoSim: String,
    rotuloFotoNao: String
) {
    Card(
        colors = CardDefaults.cardColors(containerColor = PortalCores.FundoPainel),
        border = PortalCores.BordaCartao,
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            modifier = Modifier.padding(10.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {
            AppOutlinedTextField(
                value = campo.titulo,
                onValueChange = { onChange(campo.copy(titulo = it)) },
                label = { Text("Título") },
                modifier = Modifier.fillMaxWidth(),
                colors = FormFieldDefaults.textFieldColors()
            )
            SwitchRow("Ativo", campo.ativo) { onChange(campo.copy(ativo = it)) }
            if (mostrarObrigatorio) {
                SwitchRow("Obrigatório", campo.obrigatorio) { onChange(campo.copy(obrigatorio = it)) }
            }
            if (mostrarFotos) {
                SwitchRow(rotuloFotoSim, campo.fotoObrigatoriaSeSim) {
                    onChange(campo.copy(fotoObrigatoriaSeSim = it))
                }
                if (rotuloFotoNao.isNotBlank() && rotuloFotoSim != "Foto obrigatória") {
                    SwitchRow(rotuloFotoNao, campo.fotoObrigatoriaSeNao) {
                        onChange(campo.copy(fotoObrigatoriaSeNao = it))
                    }
                }
            }
            if (onRemover != null) {
                TextButton(onClick = onRemover) { Text("Remover campo") }
            }
        }
    }
}

@Composable
private fun TagsConfigCard(
    tags: List<TagConfig>,
    escopoDe: (String) -> ColabEscopoTag,
    onEscopo: (ColabEscopoTag) -> Unit,
    onAtualizar: (String, String, String) -> Unit,
    onExcluir: (String) -> Unit,
    onAdicionar: (String, String) -> Boolean
) {
    var codigo by remember { mutableStateOf("") }
    var nome by remember { mutableStateOf("") }
    var aviso by remember { mutableStateOf<String?>(null) }
    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
        border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            TituloSecao("TAGs")
            Text(
                "Estas marcas aparecem no cadastro de usuários. O código é o que fica gravado. " +
                    "TST, ADM, Supervisor e Engenheiro têm código fixo, porque o portal usa essas marcas " +
                    "em e-mail, vetores e ativos. Dá para mudar o nome, incluir outras e excluir. " +
                    "Quem já tem uma TAG excluída continua com ela até o cadastro ser editado. Salve para aplicar.",
                style = MaterialTheme.typography.bodySmall
            )
            tags.forEach { tag ->
                val sistema = tag.id in TagConfig.SISTEMA
                Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(8.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        AppOutlinedTextField(
                            value = tag.id,
                            onValueChange = { onAtualizar(tag.id, it, tag.rotulo) },
                            enabled = !sistema,
                            label = { Text("Código") },
                            singleLine = true,
                            modifier = Modifier.weight(0.4f),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        AppOutlinedTextField(
                            value = tag.rotulo,
                            onValueChange = { onAtualizar(tag.id, tag.id, it) },
                            label = { Text("Nome") },
                            singleLine = true,
                            modifier = Modifier.weight(0.6f),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                    }
                    TextButton(
                        onClick = {
                            if (tags.size <= 1) aviso = "Precisa restar ao menos uma TAG."
                            else {
                                onExcluir(tag.id)
                                aviso = null
                            }
                        },
                        enabled = tags.size > 1
                    ) { Text("Excluir") }
                    EscopoColabDaTag(escopoDe(tag.id), onEscopo)
                }
            }
            Text("Nova TAG", fontWeight = FontWeight.SemiBold)
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                AppOutlinedTextField(
                    value = codigo,
                    onValueChange = { codigo = it },
                    label = { Text("Código") },
                    singleLine = true,
                    modifier = Modifier.weight(0.4f),
                    colors = FormFieldDefaults.textFieldColors()
                )
                AppOutlinedTextField(
                    value = nome,
                    onValueChange = { nome = it },
                    label = { Text("Nome") },
                    singleLine = true,
                    modifier = Modifier.weight(0.6f),
                    colors = FormFieldDefaults.textFieldColors()
                )
            }
            PortalOutlinedButton(
                onClick = {
                    if (onAdicionar(codigo, nome)) {
                        codigo = ""
                        nome = ""
                        aviso = null
                    } else {
                        aviso = "Use um código novo, com letras, números ou _."
                    }
                }
            ) { Text("Adicionar TAG") }
            aviso?.let { Text(it, style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.error) }
        }
    }
}

@Composable
private fun EscopoColabDaTag(escopo: ColabEscopoTag, onChange: (ColabEscopoTag) -> Unit) {
    Text("Colaboradores QSMS", fontWeight = FontWeight.SemiBold)
    Text(
        "Escolhe o que esta TAG vê no módulo. Quem também tiver outra TAG sem limite continua vendo o módulo inteiro. Salve para aplicar.",
        style = MaterialTheme.typography.bodySmall
    )
    SwitchRow("Limitar abas e documentos", escopo.limitado) {
        onChange(escopo.copy(limitado = it))
    }
    if (!escopo.limitado) return
    SwitchRow("Não editar cadastro (só ver / emitir)", escopo.somenteVer) {
        onChange(escopo.copy(somenteVer = it))
    }
    SwitchRow("Só o centro de custo do próprio cadastro", escopo.filtrarCcProprio) {
        onChange(escopo.copy(filtrarCcProprio = it))
    }
    Text("Abas do módulo", style = MaterialTheme.typography.bodySmall)
    ColabEscopo.abasMatriz.forEach { (chave, rotulo) ->
        SwitchRow(rotulo, chave in escopo.abas) { marcado ->
            val abas = if (marcado) escopo.abas + chave else escopo.abas - chave
            onChange(escopo.copy(abas = abas))
        }
    }
    Text("Abas de emissão de documentos", style = MaterialTheme.typography.bodySmall)
    ColabEscopo.abasEmissao.forEach { (chave, rotulo) ->
        SwitchRow(rotulo, chave in escopo.abas) { marcado ->
            val abas = if (marcado) escopo.abas + chave else escopo.abas - chave
            onChange(escopo.copy(abas = abas))
        }
    }
    Text("Documentos na ficha e na lista", style = MaterialTheme.typography.bodySmall)
    DocsMatriz.todos.forEach { doc ->
        SwitchRow(doc.rotulo, doc.key in escopo.docs) { marcado ->
            val docs = if (marcado) escopo.docs + doc.key else escopo.docs - doc.key
            onChange(escopo.copy(docs = docs))
        }
    }
}

@Composable
private fun SwitchRow(label: String, checked: Boolean, onChange: (Boolean) -> Unit) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(label)
        Switch(checked = checked, onCheckedChange = onChange)
    }
}
